module.exports = __webpack_public_path__ + "img/運勢書介紹頁_Web.85458f90.png";